export default "__VITE_ASSET__CgF0FUwF__"